export enum Language {
  KOREA = 1,
  ENGLISH = 2,
}

export const LangSymbolString = {
  [Language.KOREA]: 'ko',
  [Language.ENGLISH]: 'en',
};
